import "carbon-components/scss/globals/scss/styles.scss";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.scss";
import AccountFormPage from "./modules/accounts/AccountFormPage";
import AccountPage from "./modules/accounts/AccountPage";
import LoginPage from "./modules/authentications/LoginPage";
import CategoryFormpage from "./modules/categories/CategoryFormPage";
import CategoryPage from "./modules/categories/CategoryPage";
import CategoryImagePage from "./modules/categories/CategoryImagePage";
import HomePage from "./modules/HomePage";
import JobFormPage from "./modules/jobs/JobFormPage";
import JobPage from "./modules/jobs/JobPage";
import Projectspage from "./modules/project/ProjectsPage";
import ProjectFormpage from "./modules/project/ProjectFormPage";
import SkillsPage from "./modules/skills/SkillsPage";
import SkillFormPage from "./modules/skills/SkillFormPage";
import IndustryPage from "./modules/industry/IndustryPage";
import IndustryFormPage from "./modules/industry/IndustryFormPage";
import FaqPage from "./modules/faq/FaqPage";
import FaqFormPage from "./modules/faq/FaqFormPage";
import PoliciesFormPage from "./modules/policies/PoliciesFormPage";
import PoliciesPage from "./modules/policies/PoliciesPage";
import SubscriptionPage from "./modules/subscription/SubscriptionPage";
import SubscriptionFormPage from "./modules/subscription/SubscriptionFormPage";
import { useEffect } from "react";
import { setAccountType } from "./redux/actions/accountAction";
import jwtDecode from "jwt-decode";
import { useDispatch } from "react-redux";

console.log("log");

export default function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (decoded.accountType) {
          dispatch(setAccountType(decoded.accountType));
        }
      } catch (error) {
        console.error("Failed to decode token", error);
      }
    }
  }, [dispatch]);

  return (
    <Router>
      <Switch>
        <Route path="/jobs" exact component={JobPage} />
        <Route path="/jobs/form" exact component={JobFormPage} />
        <Route path="/jobs/form/:jobId" exact component={JobFormPage} />
        <Route path="/skills" exact component={SkillsPage} />
        <Route path="/skills/form" exact component={SkillFormPage} />
        <Route path="/industries" exact component={IndustryPage} />
        <Route path="/industries/form" exact component={IndustryFormPage} />
        <Route path="/projects" exact component={Projectspage} />
        <Route path="/projects/form" exact component={ProjectFormpage} />
        <Route
          path="/projects/form/:projectId"
          exact
          component={ProjectFormpage}
        />
        <Route path="/accounts" exact component={AccountPage} />
        <Route path="/accounts/form" exact component={AccountFormPage} />
        <Route path="/faqs" exact component={FaqPage} />
        <Route path="/faqs/form" exact component={FaqFormPage} />
        <Route path="/policies" exact component={PoliciesPage} />
        <Route path="/policies/form" exact component={PoliciesFormPage} />
        <Route path="/subscriptions" exact component={SubscriptionPage} />
        <Route
          path="/subscriptions/form"
          exact
          component={SubscriptionFormPage}
        />
        <Route path="/categories" exact component={CategoryPage} />
        <Route path="/categories/form" exact component={CategoryFormpage} />
        <Route
          path="/categories/:categoryId/image"
          exact
          component={CategoryImagePage}
        />
        <Route path="/authentication/login" exact component={LoginPage} />
        <Route path="/">
          <HomePage />
        </Route>
      </Switch>
    </Router>
  );
}
